export const DELIVERABILITY_STATUSES = [
  "planned",
  "staged",
  "queued",
  "sent",
  "delivered",
  "opened",
  "clicked",
  "bounced",
  "deferred",
  "dropped",
  "spam_report",
  "unsubscribed",
] as const;

export type DeliverabilityStatus = (typeof DELIVERABILITY_STATUSES)[number];

const LABELS: Record<DeliverabilityStatus, string> = {
  planned: "Planned",
  staged: "Staged",
  queued: "Queued",
  sent: "Sent",
  delivered: "Delivered",
  opened: "Opened",
  clicked: "Clicked",
  bounced: "Bounced",
  deferred: "Deferred",
  dropped: "Dropped",
  spam_report: "Spam report",
  unsubscribed: "Unsubscribed",
};

export function deliverabilityLabel(status: string): string {
  if ((DELIVERABILITY_STATUSES as readonly string[]).includes(status)) {
    return LABELS[status as DeliverabilityStatus];
  }
  return status;
}

export function emptyDeliverabilityCounts(): Record<DeliverabilityStatus, number> {
  return Object.fromEntries(DELIVERABILITY_STATUSES.map((s) => [s, 0])) as Record<
    DeliverabilityStatus,
    number
  >;
}

export function countByDeliverabilityStatus(
  rows: Array<{ deliverability_status: string }>,
): Record<DeliverabilityStatus, number> {
  const counts = emptyDeliverabilityCounts();
  for (const row of rows) {
    const status = row.deliverability_status;
    if ((DELIVERABILITY_STATUSES as readonly string[]).includes(status)) {
      counts[status as DeliverabilityStatus] += 1;
    }
  }
  return counts;
}
